module.exports = __webpack_public_path__ + "static/media/customers_import_template.95c819f1.csv";